import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Star, Navigation, CalendarCheck, Sun } from 'lucide-react';
import { STUDIO, HERO_IMG, DIRECTIONS_LINK } from './midtownData';

const MidtownHero = () => (
  <section className="relative overflow-hidden" data-testid="midtown-hero">
    <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-teal-200/40 blur-3xl" aria-hidden="true" />
    <div className="absolute top-40 -left-24 w-72 h-72 rounded-full bg-rose-200/40 blur-3xl" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-20 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7 animate-slide-up">
        <span className="inline-flex items-center gap-2 bg-white/80 backdrop-blur border border-teal-200 text-teal-800 text-xs tracking-[0.2em] uppercase px-4 py-2 rounded-full" data-testid="midtown-hero-eyebrow">
          <MapPin className="w-3.5 h-3.5" /> Midtown Sacramento · {STUDIO.zip}
        </span>
        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-serif text-gray-900 leading-[1.05]" data-testid="midtown-hero-title">
          Massage therapy in <em className="text-teal-700 not-italic sm:italic">Midtown Sacramento</em>, one client at a time.
        </h1>
        <p className="mt-6 text-base md:text-lg text-gray-700 max-w-xl leading-relaxed">
          I'm Ayumi — a CAMTC-certified massage therapist working out of a quiet private studio at {STUDIO.street}. Swedish, deep tissue and therapeutic massage, shaped around what your body needs that day.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link to="/book" className="inline-flex items-center justify-center gap-2 bg-gray-900 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-colors duration-300" data-testid="midtown-hero-book-btn">
            <CalendarCheck className="w-5 h-5" /> Book a Midtown session
          </Link>
          <a href={DIRECTIONS_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-full hover:bg-gray-900 hover:text-white transition-colors duration-300" data-testid="midtown-hero-directions-btn">
            <Navigation className="w-5 h-5" /> Get directions
          </a>
        </div>
        <a href="#lunch-reset" className="mt-6 inline-flex items-center gap-2 text-sm text-gray-800 hover:text-amber-700 transition-colors duration-300" data-testid="midtown-hero-lunch-link">
          <Sun className="w-4 h-4 text-amber-500" /> On a lunch break? Try the 30-minute Lunch Reset →
        </a>
      </div>
      <div className="lg:col-span-5 relative animate-fade-in">
        <img src={HERO_IMG} alt="Calm massage treatment room at Ayumi Suzuki's Midtown Sacramento studio" className="w-full h-[26rem] object-cover rounded-[2rem] shadow-2xl rotate-1" />
        <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl px-5 py-4 flex items-center gap-3" data-testid="midtown-hero-rating">
          <div className="flex text-amber-400">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-4 h-4 fill-current" />)}</div>
          <p className="text-sm text-gray-800"><strong>5.0</strong> · 47 reviews</p>
        </div>
      </div>
    </div>
  </section>
);

export default MidtownHero;
